import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useProjectTheme } from '@atlassian/jira-project-theme-page-container/src/controllers/project-theme/index.tsx';
import { ThemedContentLayout } from '@atlassian/jira-project-theme-page-container/src/ui/project-theme-wrapper/ProjectThemeWrapper.tsx';
import { RenderTracerMark } from '@atlassian/jira-render-tracer-analytics/src/main.tsx';
import SpaEntry, { type Props } from '@atlassian/jira-spa/src/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { MainContentSkipLink } from '../../../common/ui/page-container/page-container-skip-links/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { Props };

const SPA_TRACE_KEY = 'spa';

const DefaultLayoutContent = (props: Props) => {
	const { isInset, hasTheming } = useProjectTheme();

	const renderContent = (
		<>
			<JSErrorBoundary id="mainContentSkipLink" packageName="jiraPageContainer" fallback="unmount">
				<MainContentSkipLink />
			</JSErrorBoundary>
			<RenderTracerMark traceKey={SPA_TRACE_KEY} type="start" />
			<SpaEntry {...props} />
			<RenderTracerMark traceKey={SPA_TRACE_KEY} type="end" />
		</>
	);

	if (hasTheming) {
		return (
			<ThemedContentLayout appearance={isInset ? 'inset' : 'default'}>
				{renderContent}
			</ThemedContentLayout>
		);
	}

	return renderContent;
};

const useRouterRoute = createRouterSelector((state) => state.route);
export const Content = (props: Props) => {
	const { LayoutOverrideComponent } = useRouterRoute();
	if (LayoutOverrideComponent !== undefined) {
		return (
			<>
				<RenderTracerMark traceKey={SPA_TRACE_KEY} type="start" />
				<SpaEntry {...props} />
				<RenderTracerMark traceKey={SPA_TRACE_KEY} type="end" />
			</>
		);
	}
	return <DefaultLayoutContent {...props} />;
};
